import { render, staticRenderFns } from "./distributionLog.vue?vue&type=template&id=1a8e2be6&scoped=true"
import script from "./distributionLog.vue?vue&type=script&lang=js"
export * from "./distributionLog.vue?vue&type=script&lang=js"
import style0 from "./distributionLog.vue?vue&type=style&index=0&id=1a8e2be6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8e2be6",
  null
  
)

export default component.exports